import React, { ReactElement } from 'react';
import { BoxedRow, Checkbox } from '@telefonica/mistica';
import './index.scss';

export interface BoxedRowListData {
    index?: string | number;
    title: string;
    description?: string;
    asset?: any;
    headline?: any;
    extra?: ReactElement;
    checkbox?: { default: boolean; show: boolean };
    arrow?: boolean;
    handleSelection: (event: {
        index?: number | string;
        title?: string;
        description?: string;
        checked?: boolean;
    }) => void;
}

export const BoxedRowList: React.FC<BoxedRowListData> = ({
    index,
    title,
    description,
    asset,
    headline,
    extra,
    checkbox = { default: false, show: false },
    arrow = true,
    handleSelection,
}: BoxedRowListData) => {
    const handleCheckbox = (check: boolean) => {
        return onHandleSelection(check);
    };

    const onHandleSelection = (checked?: boolean) => {
        return handleSelection({ index, title, description, checked });
    };

    return (
        <div className={arrow ? 'boxed-row--arrow' : 'boxed-row'}>
            <BoxedRow
                headline={headline ? headline : undefined}
                asset={asset ? asset : undefined}
                title={title}
                description={description}
                extra={extra}
                right={
                    checkbox.show ? (
                        <Checkbox
                            name={`checkbox-${index}`}
                            onChange={handleCheckbox}
                            defaultChecked={checkbox?.default}
                        />
                    ) : undefined
                }
                onPress={() => {
                    onHandleSelection();
                }}
            />
        </div>
    );
};

export default BoxedRowList;
